import { SummaryMetricInput } from "reports/utils/metricUtils";
import { MetricEnum, MetricUnitsEnum } from "reports/utils/metricTypes";
import { PnlBreakdown } from "../../../../getters/pnlBreakdownGetter/pnlBreakdownTypes";
import { PnlCategoriesWithTagsAndProducingTags } from "../../../../types";

export const getAutoTaggingPercent = (data: PnlBreakdown) => {
  const autoTags = [
    "Minor Setting",
    "Start of Shift",
    "Start of Shift Loss",
    "End of Shift",
    "End of Shift Loss",
    "Break",
    "Break Loss",
  ];

  const autoTaggingTime = PnlCategoriesWithTagsAndProducingTags.reduce(
    (accum, category) => {
      const autoTagTime = data[category as string].tags.reduce(
        (acc, tag) =>
          autoTags.includes(tag.tagName) ? acc + tag.durationMs : acc,
        0
      );
      return accum + autoTagTime;
    },
    0
  );

  const totalDowntime =
    data.planned.durationMs +
    data.unplanned.durationMs +
    data.waiting.durationMs +
    data.unknown.durationMs;

  return totalDowntime ? (autoTaggingTime / totalDowntime) * 100 : 0;
};

export const getPartsLoss = ({ unplanned, waiting, unknown }: PnlBreakdown) => {
  return unplanned.targetOutput + waiting.targetOutput + unknown.targetOutput;
};

export const getOperatorTagging = (data: PnlBreakdown) => {
  const operatorTaggingPercent =
    (data.taggingPercent ? data.taggingPercent : 0) -
    getAutoTaggingPercent(data);

  return operatorTaggingPercent < 0 ? 0 : operatorTaggingPercent;
};

export const getCustomSummaryMetricsInputListWithPnlBreakdown = (
  data: PnlBreakdown
): SummaryMetricInput[] => {
  const partsLoss = getPartsLoss(data);
  return [
    {
      title: "Parts Loss",
      customValue: partsLoss,
      unit: MetricUnitsEnum.count,
    },
  ];
};

export const getSummaryMetricsListForShiftAndProcessBreakdowns = () => {
  return [
    { name: MetricEnum.OEE, color: "black" },
    { name: MetricEnum.PERF, color: "black" },
    { name: MetricEnum.UPTIME, color: "black" },
    { name: MetricEnum.COUNT, title: "Parts Produced" },
  ];
};
